<template>
  <v-form v-model="valid">
    <v-flex md12 v-if="!loadingCaseForms" class="ph16">
      <v-flex md2 d-inline-flex>
        I,
      </v-flex>
      <v-flex md5 d-inline-flex>
        <v-text-field
          class="required"
          label="Name"
          v-model="localClientFormData.name"
          :rules="nameRules"
        />
      </v-flex>
      <v-flex md5 xs12 d-inline-flex>
        <v-text-field
          class="required"
          label="NRIC/FIN Number"
          v-model="localClientFormData.nric_fin_number"
          :rules="nricFinNumberRules"
        />
      </v-flex>
      <v-flex d-inline-flex>
        have acknowledged receipt of and accepted the above mentioned Service Agreement that outlines the terms and
        conditions of the services provided, and hereby authorise “Direct Funeral Services Pte Ltd” to bill myself based
        on the above information provided.
      </v-flex><br /><br />
      <v-flex d-inline-flex>
        I acknowledge that our funeral director has shown and clearly explained the terms and conditions of products and services. In addition, I confirm that I have fully understood and agree to the terms and conditions stated above.
      </v-flex><br /><br />
      <v-flex xs12>
        <v-text-field
          class="required"
          label="Contact Number"
          v-model="localClientFormData.contact_number"
          :rules="contactNumberRules"
        />
      </v-flex>
      <v-flex xs12>
        <v-text-field
          class="required"
          label="Email"
          v-model="localClientFormData.email"
          :rules="emailRules"
        />
      </v-flex>
      <v-flex xs12>
        <v-text-field
          class="required"
          label="Mailing address"
          v-model="localClientFormData.mailing_address"
          :rules="mailingAddressRules"
        />
        <v-checkbox
          label="Mailing Address same as per Deceased's Address"
          v-model="localClientFormData.mailing_address_same"
        />
      </v-flex>
    </v-flex>
  </v-form>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        formData: 'getOnBoardClientFormAnswers',
        editable: 'isOnBoardClientFormAnswersEditable',
        loadingCaseForms: 'getLoadingFormsStatus'
      })
    },
    data () {
      return {
        localClientFormData: [],
        nameRules: [
          v => !!v || 'Required'
        ],
        nricFinNumberRules: [
          v => !!v || 'Required'
        ],
        contactNumberRules: [
          value => {
            let rules = true

            if (value.indexOf(',') >= 0) {
              rules = 'No commas allowed'
            }
            if (value.indexOf('.') >= 0) {
              rules = 'No dots allowed'
            }
            if (value.indexOf(';') >= 0) {
              rules = 'No semicolons allowed'
            }
            if (value.indexOf(' ') >= 0) {
              rules = 'No spaces allowed'
            }
            if (/[a-z]/i.test(value)) {
              rules = 'No letters allowed'
            }
            if (value[0] !== '+') {
              rules = 'Must start with a plus ("+") sign'
            }
            if (value[1] !== '6' || value[2] !== '5') {
              rules = 'Country code (+65) is required'
            }
            if (!value) {
              rules = 'This field is required'
            }

            return rules
          }
        ],
        emailRules: [
          v => /\S+@\S+\.\S+/.test(v) || 'Valid email is required'
        ],
        mailingAddressRules: [
          v => !!v || 'Required'
        ],
        valid: false
      }
    },
    props: {
      clientName: String,
      newreturn: String
    },
    watch: {
      valid (status) {
        this.$store.commit('updateClientOnBoardForm', this.localClientFormData)
        this.$emit('valid:changed', status)
      },
      localClientFormData: {
        handler (newObject) {
          this.$emit('clientdata:input', newObject)
        },
        deep: true
      },
      clientName (name) {
        this.localClientFormData.name = name
      },
      formData () {
        this.caseSelected = this.caseid
        this.localClientFormData = this.formData.client_form_data
      },
      newreturn (value) {
        this.localClientFormData.new_return = this.value
      }
    },
    created () {
      this.localClientFormData = this.formData.client_form_data
      this.localClientFormData.new_return = this.newreturn
    },
    methods: {
      mailingAddressClick (value) {
        if (value) {
          this.localClientFormData.mailing_address = this.localClientFormData.email
        } else {
          this.localClientFormData.mailing_address = null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DfsServiceAgreementClientData.vue?637a3ebb